/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Scope_TitleInputs */

const en_svc_n8n_scope_title = /** @type {(inputs: Svc_N8n_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why n8n, and when not.`)
};

const lv_svc_n8n_scope_title = /** @type {(inputs: Svc_N8n_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kad n8n ir piemērots un kad nav.`)
};

/**
* | output |
* | --- |
* | "Why n8n, and when not." |
*
* @param {Svc_N8n_Scope_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_scope_title = /** @type {((inputs?: Svc_N8n_Scope_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Scope_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_scope_title(inputs)
	return en_svc_n8n_scope_title(inputs)
});